import { getLocale } from "../runtime";

const sv_paymentandshipping = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Betalning & Frakt`
};

const paymentandshipping = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_paymentandshipping(inputs)
	return "paymentAndShipping";
};

export { paymentandshipping as "paymentAndShipping" };